import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
    min-height: 692px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 0;
    overflow: hidden;
    background: linear-gradient(108deg, rgba(197, 197, 0, 0.8) 8%, rgba(137, 137, 12, 0.8) 80%);
`;

export const FormWrap = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (max-width: 400px) {
        height: 100%;
    }
`;

export const Icon = styled(Link)`
    margin-left: 32px;
    margin-top: 32px;
    text-decoration: none;
    color: #000;
    font-weight: 700;
    font-size: 32px;

    @media screen and (max-width: 480px) {
        margin-left: 16px;
        margin-top: 8px;
    }
`;

export const FormContent = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (max-width: 480px) {
        padding: 10px;
    }
`;

export const Form = styled.form`
    background: #010101;
    max-width: 400px;
    height: auto;
    width: 100%;
    z-index: 1;
    display: grid;
    margin: 0 auto;
    padding: 60px 45px;
    border-radius: 14px;
    box-shadow: 0 1px 40px rgba(1, 1, 1, 1);

    @media screen and (max-width: 400px) {
        padding: 32px 32px;
    }
`;

export const FormH1 = styled.h1`
    margin-bottom: 20px;
    color: #fff;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
`;

export const FormLabel = styled.label`
    margin-bottom: 5px;
    font-size: 14px;
    color: #fff;
`;
export const FormInput = styled.input`
    padding: 16px 16px;
    margin-bottom: 15px;
    border: none;
    border-radius: 114px;
    ::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
`;

export const FormButton = styled.button`
    background: #01bf71;
    padding: 16px 0;
    border: none;
    border-radius: 8px;
    color: #000;
    font-size: 20px;
    cursor: pointer;
    margin-bottom: 1rem;
`;
export const Text = styled.span`
    text-align: center;
    margin-top: 20px;
    color: #f54848;
    font-size: 16x;
    cursor: pointer;
`;
